import {
    dateFormatter,
    dateTimeFormatter
  } from 'common/utils/valueFormatters';

export const signInGridColumns = [
    {
        field: 'type',
        headerName: 'Operation',
        cellClass: 'keyword',
        width:50,
    },
    {
        field: 'clockDate',
        headerName: 'Clock Date',
        width:70,
    },
    {
        field: 'remark',
        headerName: 'Remark',
        width:130,
    },
    {
        field: 'status',
        headerName: 'Status',
        cellClass: 'non-number',
        cellRenderer: 'tagComponent',
        cellRendererParams: {
            colorMap: {
                NEW: 'green',
                REJECTED: 'red',
                PASS: '#FF9E28'
            }
        },
        width:70,
    },
    {
        field: 'feedback',
        headerName: 'Feedback',
        cellClass: 'non-number',
        width:130,
    },
    {
        field: 'createdBy',
        headerName: 'Clock By',
        width:70,
    },
    {
        field: 'createdOn',
        headerName: 'Clock Time',
        width:120,
    },
];

export const leaveGridColumns = [
    {
        field: 'startDate',
        headerName: 'StartDate',
        valueFormatter: dateFormatter,
        width:70,
    },
    {
        field: 'endDate',
        headerName: 'End Date',
        valueFormatter: dateFormatter,
        width:70,
    },
    {
        field: 'remark',
        headerName: 'Remark',
        width:130,
    },
    {
        field: 'createdOn',
        headerName: 'Apply Time',
        valueFormatter: dateTimeFormatter,
        width:120,
    },
];


export const extraHoursGridColumns = [
    {
        field: 'date',
        headerName: 'Date',
        cellClass: 'keyword',
        width:70,
    },
    {
        field: 'applyHours',
        headerName: 'Extra Hours',
        cellClass: 'number',
        width:70,
    },
    {
        field: 'status',
        headerName: 'Status',
        cellClass: 'non-number',
        cellRenderer: 'tagComponent',
        cellRendererParams: {
            colorMap: {
                NEW: 'green',
                REJECTED: 'red',
                PASS: '#FF9E28'
            }
        },
        width:70,
    },
    {
        field: 'remark',
        headerName: 'Remark',
        width:130,
    },
    {
        field: 'feedback',
        headerName: 'Feedback',
        cellClass: 'non-number',
        width:130,
    },
];